import React from 'react';
import AvatarType1 from './type1';
import AvatarType2 from './type2';
import AvatarType3 from './type3';
import AvatarType4 from './type4';
import AvatarType5 from './type5';
import AvatarType6 from './type6';

export default class Avatar extends React.Component {
    render() {
        const avatars = [AvatarType1, AvatarType2, AvatarType3, AvatarType4, AvatarType5, AvatarType6];
        const index = this.props.number % (avatars.length - 1);
        const Avatar = avatars[index];
        return <Avatar {...this.props} />;
    }
}


// WEBPACK FOOTER //
// ./src/components/Presentation/Avatar/index.js